import { Box, Chip, Stack, Typography } from "@mui/material";

interface ChatInboxHeaderProps {
  unreadCount: number;
}

export function ChatInboxHeader(props: ChatInboxHeaderProps) {
  const { unreadCount } = props;

  return (
    <Box sx={{ px: 2, pt: 2, pb: 1.5 }}>
      <Stack direction="row" alignItems="center" spacing={1}>
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          Messages
        </Typography>
        {unreadCount > 0 && (
          <Chip
            label={`${unreadCount} unread`}
            color="primary"
            size="small"
            sx={{ height: 20, fontWeight: 700, fontSize: 11 }}
          />
        )}
      </Stack>
    </Box>
  );
}
